import React from 'react'
import { Box, Typography, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { SkuInfo } from '../../types'
import { formatExpirationDate } from '../../../../utils/dateHelper'
import { ProductOrigin } from '../../../../interfaces/Producto/ProductOrigins'

interface SkuItemProps {
  sku: SkuInfo
  isCollapsed?: boolean
  onDelete?: (sku: string) => void
  disabled?: boolean
  productOrigins: ProductOrigin[] | undefined
  getBackgroundStyle: (
    expirationDate: string | undefined,
    skuProductOrigin: number
  ) => React.CSSProperties
  getTextColor: (
    expirationDate: string | undefined,
    skuProductOrigin: number
  ) => string
}

export const SkuItem: React.FC<SkuItemProps> = ({
  sku,
  isCollapsed = false,
  onDelete,
  disabled = false,
  productOrigins,
  getBackgroundStyle,
  getTextColor
}) => {
  // Sacamos la configuración de días
  const skuProductOriginDays =
    productOrigins?.find((el) => el.productOriginId === sku.productOriginid)
      ?.expirationDays || 0

  const renderBatchInfo = () => {
    if (!sku.batch?.batchNumber && !sku.batch?.expirationDate) {
      return null
    }

    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '2px',
          marginLeft: isCollapsed ? '0px' : '4px'
        }}
      >
        {sku.batch.batchNumber && (
          <Typography
            variant='body2'
            style={{
              fontSize: '0.75rem',
              color: getTextColor(
                sku.batch?.expirationDate || undefined,
                skuProductOriginDays
              )
            }}
          >
            Lote: {sku.batch.batchNumber}
          </Typography>
        )}
        {sku.batch.batchNumber && sku.batch.expirationDate && (
          <Typography
            variant='body2'
            style={{
              fontSize: '0.75rem',
              marginLeft: '8px',
              color: getTextColor(
                sku.batch?.expirationDate || undefined,
                skuProductOriginDays
              )
            }}
          >
            |
          </Typography>
        )}
        {sku.batch.expirationDate && (
          <Typography
            variant='body2'
            style={{
              fontSize: '0.75rem',
              marginLeft: sku.batch.batchNumber ? '8px' : '0px',
              color: getTextColor(
                sku.batch?.expirationDate || undefined,
                skuProductOriginDays
              )
            }}
          >
            Exp: {formatExpirationDate(sku.batch.expirationDate, 'dd/MM/yyyy')}
          </Typography>
        )}
      </Box>
    )
  }

  if (isCollapsed) {
    return (
      <Box
        style={{
          flex: 1,
          marginLeft: '8px',
          ...getBackgroundStyle(
            sku.batch?.expirationDate || undefined,
            skuProductOriginDays
          ),
          padding: '8px',
          borderRadius: '4px',
          marginBottom: '8px'
        }}
      >
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Typography
            variant='body2'
            style={{
              color: getTextColor(
                sku.batch?.expirationDate || undefined,
                skuProductOriginDays
              )
            }}
          >
            {sku.sku}
          </Typography>
          <Typography
            variant='body2'
            style={{
              color: getTextColor(
                sku.batch?.expirationDate || undefined,
                skuProductOriginDays
              )
            }}
          >
            x{sku.checkedQty}
          </Typography>
        </Box>
        {renderBatchInfo()}
      </Box>
    )
  }

  return (
    <Box
      style={{
        ...getBackgroundStyle(
          sku.batch?.expirationDate || undefined,
          skuProductOriginDays
        ),
        padding: '8px',
        borderRadius: '4px',
        marginBottom: '8px'
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            flex: 1
          }}
        >
          <Typography
            variant='body2'
            style={{
              color: getTextColor(
                sku.batch?.expirationDate || undefined,
                skuProductOriginDays
              )
            }}
          >
            {sku.sku}
          </Typography>
          <Typography
            variant='body2'
            style={{
              marginLeft: 'auto',
              marginRight: '8px',
              color: getTextColor(
                sku.batch?.expirationDate || undefined,
                skuProductOriginDays
              )
            }}
          >
            x{sku.checkedQty}
          </Typography>
        </Box>
        {onDelete && (
          <IconButton
            disabled={disabled}
            size='small'
            onClick={() => onDelete(sku.sku)}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      {renderBatchInfo()}
    </Box>
  )
}
